import { BUILD_MODES } from "../constants";

export const isDevelopmentBuild = () => {
  return process.env.NODE_ENV === BUILD_MODES.DEVELOPMENT;
};
